// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var Scalars = require("../../scalars/Scalars.bs.js");
var DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var UseNavigationStopper = require("../common/Hooks/UseNavigationStopper.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var AgentMarketingProfileAboutSettingsQuery_graphql = require("../../__generated__/AgentMarketingProfileAboutSettingsQuery_graphql.bs.js");
var AgentMarketingProfileAboutSettingsMutation_graphql = require("../../__generated__/AgentMarketingProfileAboutSettingsMutation_graphql.bs.js");
var AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.bs.js");

var convertFragment = AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = AgentMarketingProfileAboutSettingsMutation_graphql.Internal.convertVariables;

var convertResponse = AgentMarketingProfileAboutSettingsMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = AgentMarketingProfileAboutSettingsMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AgentMarketingProfileAboutSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, AgentMarketingProfileAboutSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

var validators = {
  specialties: undefined,
  bio: undefined
};

function initialFieldsStatuses(_input) {
  return {
          specialties: "Pristine",
          bio: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            specialties: "Pristine",
            bio: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, param, param$1) {
  var match_0 = {
    TAG: "Ok",
    _0: input.specialties
  };
  var match_0$1 = {
    TAG: "Ok",
    _0: input.bio
  };
  var specialtiesResult = match_0;
  var specialtiesResult$1;
  if (specialtiesResult.TAG === "Ok") {
    var bioResult = match_0$1;
    if (bioResult.TAG === "Ok") {
      return {
              TAG: "Valid",
              output: {
                bio: bioResult._0,
                specialties: specialtiesResult._0
              },
              fieldsStatuses: {
                specialties: {
                  TAG: "Dirty",
                  _0: specialtiesResult,
                  _1: "Hidden"
                },
                bio: {
                  TAG: "Dirty",
                  _0: bioResult,
                  _1: "Hidden"
                }
              },
              collectionsStatuses: undefined
            };
    }
    specialtiesResult$1 = specialtiesResult;
  } else {
    specialtiesResult$1 = specialtiesResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            specialties: {
              TAG: "Dirty",
              _0: specialtiesResult$1,
              _1: "Hidden"
            },
            bio: {
              TAG: "Dirty",
              _0: match_0$1,
              _1: "Hidden"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurSpecialtiesField" :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.specialties, state.fieldsStatuses.specialties, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  specialties: status,
                                  bio: init.bio
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurBioField" :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.bio, state.fieldsStatuses.bio, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  specialties: init.specialties,
                                  bio: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateSpecialtiesField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.specialties, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            specialties: status,
                                            bio: init.bio
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateBioField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.bio, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            specialties: init.specialties,
                                            bio: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                specialties: "Pristine",
                                bio: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                specialties: "Pristine",
                                bio: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: Caml_option.some(map(Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateSpecialties: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateSpecialtiesField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateBio: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateBioField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurSpecialties: (function () {
              dispatch("BlurSpecialtiesField");
            }),
          blurBio: (function () {
              dispatch("BlurBioField");
            }),
          specialtiesResult: Formality.exposeFieldResult(state.fieldsStatuses.specialties),
          bioResult: Formality.exposeFieldResult(state.fieldsStatuses.bio),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.specialties;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.bio;
              if (typeof tmp$1 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function initialInputFromFragment(fragment) {
  return {
          bio: fragment.bio,
          specialties: fragment.specialties
        };
}

function AgentMarketingProfileAboutSettings$Form$RichTextField(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Label.make, {
                            labelText: props.labelText
                          }),
                      className: "pt-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(RichTextEditorV5.make, {
                              initialContent: props.initialValue,
                              onChange: props.onChange,
                              onBlur: props.onBlur,
                              toolbar: "withSingleHeadingLevel",
                              proseStyle: "md"
                            }),
                        Core__Option.getOr(Core__Option.map(props.helpText, (function (text) {
                                    return JsxRuntime.jsx("div", {
                                                children: text,
                                                className: "text-base text-gray-500"
                                              });
                                  })), null)
                      ],
                      className: "mt-2 sm:col-span-2 sm:mt-0 space-y-3"
                    })
              ],
              className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
            });
}

var RichTextField = {
  make: AgentMarketingProfileAboutSettings$Form$RichTextField
};

function AgentMarketingProfileAboutSettings$Form$ConfirmationDialog(props) {
  var formStatus = props.formStatus;
  var onDiscard = props.onDiscard;
  var onCancel = props.onCancel;
  var onConfirm = props.onConfirm;
  var tmp;
  tmp = typeof formStatus !== "object" || formStatus.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(Alert.$$Error.make, {
          title: "There was an error updating your account. Please try again"
        });
  var tmp$1;
  tmp$1 = typeof formStatus !== "object" ? (
      formStatus === "Editing" ? false : true
    ) : (
      formStatus.TAG === "Submitting" ? true : false
    );
  return JsxRuntime.jsx(DialogV5.make, {
              title: "Unsaved changes",
              isOpen: props.isOpen,
              ariaLabel: "Unsaved changes",
              onDismiss: onCancel,
              size: "Large",
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: "You have unsaved changes. Do you want to save them?",
                            className: "text-base text-gray-500"
                          }),
                      tmp,
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    onClick: (function (param) {
                                        onCancel();
                                      }),
                                    children: "Cancel"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                            onClick: (function (param) {
                                                onDiscard();
                                              }),
                                            children: "Discard"
                                          }),
                                      JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                            onClick: (function (param) {
                                                onConfirm();
                                              }),
                                            disabled: tmp$1,
                                            children: "Save"
                                          })
                                    ],
                                    className: "flex justify-end gap-3"
                                  })
                            ],
                            className: "flex justify-between"
                          })
                    ],
                    className: "space-y-4"
                  })
            });
}

var ConfirmationDialog = {
  make: AgentMarketingProfileAboutSettings$Form$ConfirmationDialog
};

function AgentMarketingProfileAboutSettings$Form(props) {
  var marketingProfile = use(props.marketingProfile);
  var match = use$1();
  var mutate = match[0];
  var form = useForm(initialInputFromFragment(marketingProfile), (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          mutate({
                input: {
                  bio: param.bio,
                  specialties: param.specialties
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var result = param.updateAgentMarketingProfileAboutSection;
                  if (result !== undefined && result.__typename === "AgentMarketingProfileAboutSectionUpdated") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure();
                  }
                }), (function (param) {
                  notifyOnFailure();
                }), undefined);
        }));
  var match$1 = React.useState(function () {
        return JSON.stringify(form.input);
      });
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsConfirmationDialogOpen = match$2[1];
  var isConfirmationDialogOpen = match$2[0];
  var navigate = UseNavigationStopper.use(match$1[0] !== JSON.stringify(form.input), (function () {
          setIsConfirmationDialogOpen(function (param) {
                return true;
              });
        }));
  React.useEffect((function () {
          var match = form.status;
          if (typeof match !== "object" && match === "Submitted") {
            if (isConfirmationDialogOpen && navigate !== undefined) {
              navigate();
            }
            
          }
          
        }), [
        form.status,
        isConfirmationDialogOpen,
        navigate
      ]);
  var match$3 = form.status;
  var tmp;
  tmp = typeof match$3 !== "object" ? (
      match$3 === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
              title: "Your account was updated"
            })
    ) : (
      match$3.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Alert.$$Error.make, {
                    title: "There was an error updating your account. Please try again"
                  }),
              className: "mt-4"
            })
    );
  return JsxRuntime.jsxs("form", {
              children: [
                JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Form$ConfirmationDialog, {
                      onConfirm: (function () {
                          if (form.valid()) {
                            return form.submit();
                          } else {
                            return setIsConfirmationDialogOpen(function (param) {
                                        return false;
                                      });
                          }
                        }),
                      isOpen: isConfirmationDialogOpen,
                      onCancel: (function () {
                          setIsConfirmationDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      onDiscard: (function () {
                          setIsConfirmationDialogOpen(function (param) {
                                return false;
                              });
                          form.reset();
                          if (navigate !== undefined) {
                            return navigate();
                          }
                          
                        }),
                      formStatus: form.status
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Form$RichTextField, {
                                      onChange: (function (value) {
                                          form.updateBio((function (input, value) {
                                                  return {
                                                          bio: value,
                                                          specialties: input.specialties
                                                        };
                                                }), value);
                                        }),
                                      onBlur: (function (param) {
                                          form.blurBio();
                                        }),
                                      initialValue: marketingProfile.bio,
                                      labelText: "Bio"
                                    }),
                                JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Form$RichTextField, {
                                      onChange: (function (value) {
                                          form.updateSpecialties((function (input, value) {
                                                  return {
                                                          bio: input.bio,
                                                          specialties: value
                                                        };
                                                }), value);
                                        }),
                                      onBlur: (function (param) {
                                          form.blurSpecialties();
                                        }),
                                      initialValue: marketingProfile.specialties,
                                      labelText: "Specialties",
                                      helpText: "We recommend formatting your specialties as a bullet list."
                                    })
                              ],
                              className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                      href: Scalars.$$URL.toString(marketingProfile.publicUrl),
                                      target: "_blank",
                                      children: "View Profile"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                              disabled: form.submitting,
                                              children: "Save changes"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: tmp,
                                              role: "status"
                                            })
                                      ],
                                      className: "flex flex-col items-end gap-3"
                                    })
                              ],
                              className: "flex justify-between items-baseline"
                            })
                      ],
                      className: "space-y-6"
                    })
              ],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  form.submit();
                })
            });
}

var Form = {
  Fragment: Fragment,
  Mutation: Mutation,
  Config: Config,
  initialInputFromFragment: initialInputFromFragment,
  RichTextField: RichTextField,
  ConfirmationDialog: ConfirmationDialog,
  make: AgentMarketingProfileAboutSettings$Form
};

function AgentMarketingProfileAboutSettings$Header(props) {
  var displayName = MarketingProfileSubpages.Page.Agent.useDisplayName();
  var breadcrumbs = [
    {
      name: "Marketing Profile",
      href: "/account/marketing_profile"
    },
    {
      name: displayName("Bio"),
      href: MarketingProfileSubpages.Page.Agent.path("Bio")
    }
  ];
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsx(Breadcrumbs.make, {
                      pages: breadcrumbs
                    }),
                JsxRuntime.jsx("h2", {
                      children: displayName("Bio"),
                      className: "text-zinc-800 text-3xl font-medium"
                    })
              ],
              className: "space-y-3 border-b pb-2"
            });
}

var Header = {
  make: AgentMarketingProfileAboutSettings$Header
};

var convertVariables$1 = AgentMarketingProfileAboutSettingsQuery_graphql.Internal.convertVariables;

var convertResponse$1 = AgentMarketingProfileAboutSettingsQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = AgentMarketingProfileAboutSettingsQuery_graphql.Internal.convertWrapRawResponse;

var use$2 = RescriptRelay_Query.useQuery(convertVariables$1, AgentMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1);

var useLoader = RescriptRelay_Query.useLoader(convertVariables$1, AgentMarketingProfileAboutSettingsQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(AgentMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(AgentMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

var fetchPromised = RescriptRelay_Query.fetchPromised(AgentMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

var retain = RescriptRelay_Query.retain(AgentMarketingProfileAboutSettingsQuery_graphql.node, convertVariables$1);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function AgentMarketingProfileAboutSettings(props) {
  var match = use$2(undefined, undefined, undefined, undefined);
  var marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "AgentMarketingProfile") {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Header, {}),
                        JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Form, {
                              marketingProfile: marketingProfile.fragmentRefs
                            })
                      ],
                      className: "space-y-8 sm:space-y-0"
                    }),
                className: "bg-white p-6 shadow-sm rounded space-y-8"
              });
  } else {
    return UnselectedUnionMemberError.raise("Unselected union member: " + marketingProfile._0);
  }
}

var make = AgentMarketingProfileAboutSettings;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
